/**
 * Extract plain text from HTML
 * Removes HTML tags, scripts, styles, and normalizes whitespace
 */
export const extractPlainText = (html: string): string => {
  if (!html) return '';

  let text = html;

  // Remove script and style tags completely
  text = text.replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '');
  text = text.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');

  // Remove comments
  text = text.replace(/<!--[\s\S]*?-->/g, '');

  // Convert <br>, <br/>, <br /> to newline
  text = text.replace(/<br\s*\/?>/gi, '\n');

  // Convert block closing tags to newline
  text = text.replace(/<\/(p|div|li|blockquote|h[1-6])>/gi, '\n');

  // Convert <li> to newline with space
  text = text.replace(/<li[^>]*>/gi, '\n');

  // Remove all remaining HTML tags
  text = text.replace(/<[^>]*>/g, '');

  // Decode HTML entities using textarea trick
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  text = textarea.value;

  // Replace multiple spaces with single space
  text = text.replace(/\s+/g, ' ');

  // Remove leading/trailing whitespace
  text = text.trim();

  return text;
};

/**
 * Count words in HTML content
 * Extracts plain text first, then counts words
 */
export const countWords = (html: string): number => {
  const plainText = extractPlainText(html);

  // Split by whitespace and filter out empty strings
  const words = plainText
    .split(/\s+/)
    .filter((word: string) => word.length > 0);

  return words.length;
};
